// src/Footer/Footer.js
import React from 'react';
import './Footer.css';
import Chatbot from "../components/Chatbot";

const Footer = () => {
  // Générer des flux de données pour l'effet de fond
  const generateDataStream = (count) => {
    return [...Array(count)].map((_, i) => {
      const data = [
        "01010101", "10101010", "11110000", "00001111",
        "01100110", "10011001", "11001100", "00110011"
      ];
      return (
          <div
              key={i}
              className="data-stream-item"
              style={{
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 10}s`,
                animationDuration: `${10 + Math.random() * 10}s`
              }}
          >
            {data[Math.floor(Math.random() * data.length)]}
          </div>
      );
    });
  };

  // URL pour le QR Code (utiliser un service en ligne pour générer le QR code)
  const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent('https://applicodetech.sn')}&color=61DAFB&bgcolor=0a0a0a&margin=10`;

  return (
      <footer className="footer-tech-container">
        {/* Effets de fond technologiques */}
        <div className="footer-tech-background">
          <div className="footer-grid-pattern"></div>
          <div className="footer-connection-lines"></div>
          <div className="footer-data-stream">
            {generateDataStream(20)}
          </div>

          {/* Points de connexion */}
          <div className="connection-points-footer">
            <div className="connection-point-footer" style={{top: '20%', left: '10%'}}></div>
            <div className="connection-point-footer" style={{top: '20%', right: '10%'}}></div>
            <div className="connection-point-footer" style={{bottom: '20%', left: '10%'}}></div>
            <div className="connection-point-footer" style={{bottom: '20%', right: '10%'}}></div>
          </div>
        </div>

        <div className="container footer-tech-content">
          {/* Grille principale */}
          <div className="footer-tech-grid">
            {/* Colonne 1 - Logo et description */}
            <div className="footer-col-logo">
              <div className="footer-hologram-logo">
                <div className="logo-hologram"></div>
                <img
                    src="/ACT.png"
                    alt="Applicodetech Logo"
                    className="logo-tech-image"
                />
              </div>
              <h3 className="footer-brand-tech">Applicodetech</h3>
              <p className="footer-description-tech">
                ApplicodeTech est une start-up IT dédiée à fournir
                des solutions informatiques personnalisées pour les
                entreprises, les aidant à optimiser leurs opérations
                et à renforcer leur présence numérique.
              </p>

              {/* QR Code Tech */}
              <div className="qr-tech-container">
                <div className="qr-title">SCAN TO VISIT</div>
                <a
                    href="https://applicodetech.sn"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="qr-real"
                >
                  <img
                      src={qrCodeUrl}
                      alt="QR Code pour applicodetech.sn"
                      className="qr-image"
                      onError={(e) => {
                        // Fallback si le QR code ne charge pas
                        e.target.style.display = 'none';
                        e.target.parentElement.innerHTML = `
                      <div style="
                        width: 100%;
                        height: 100%;
                        background: linear-gradient(45deg, #61DAFB, #ff7e5f);
                        border-radius: 5px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        color: #000;
                        font-weight: bold;
                        text-align: center;
                        padding: 10px;
                      ">
                        <div style="font-size: 1.5rem; margin-bottom: 5px;">🔗</div>
                        <div style="font-size: 0.7rem;">applicodetech.sn</div>
                      </div>
                    `;
                      }}
                  />
                </a>
                <div className="qr-text">applicodetech.sn</div>
              </div>
            </div>

            {/* Colonne 2 - Liens utiles */}
            <div className="footer-col-content">
              <h3 className="footer-title-tech">Liens utiles</h3>
              <ul className="footer-links-tech">
                <li><a href="/projets" className="footer-link-tech">Projets</a></li>
                <li><a href="/formation" className="footer-link-tech">Formation</a></li>
                <li><a href="/services" className="footer-link-tech">Nos services</a></li>
                <li><a href="/blog" className="footer-link-tech">Blog</a></li>
                <li><a href="/ui-ux" className="footer-link-tech">UI/UX</a></li>
              </ul>
            </div>

            {/* Colonne 3 - Contacts */}
            <div className="footer-col-content">
              <h3 className="footer-title-tech">Contacts</h3>
              <div className="footer-contact-tech">
                <div className="contact-item-tech">
                  <span className="contact-icon-tech">📞</span>
                  <span className="contact-text">+221 70 980 89 60</span>
                </div>
                <div className="contact-item-tech">
                  <span className="contact-icon-tech">✉️</span>
                  <span className="contact-text">contact@applicodetech.com</span>
                </div>
                <div className="contact-item-tech">
                  <span className="contact-icon-tech">📍</span>
                  <span className="contact-text">Saint-Louis | BP : Rue de Paris | 32000</span>
                </div>
              </div>
            </div>

            {/* Colonne 4 - Réseaux sociaux & Newsletter */}
            <div className="footer-col-content">
              <h3 className="footer-title-tech">Suivez-nous</h3>
              <div className="social-tech-container">
                <div className="social-icons-tech">
                  <a href="https://www.facebook.com/100089077000864/about/" target="_blank" rel="noopener noreferrer" className="social-icon-tech" aria-label="Facebook">
                    <span className="icon">fb</span>
                  </a>
                  <a href="https://www.linkedin.com/company/91647581/admin/dashboard/" target="_blank" rel="noopener noreferrer" className="social-icon-tech" aria-label="LinkedIn">
                    <span className="icon">in</span>
                  </a>
                </div>
                <div className="newsletter-tech">
                  <h4 className="newsletter-title">Newsletter Tech</h4>
                  <p className="newsletter-text-tech">
                    Recevez les dernières innovations tech directement dans votre boîte mail.
                  </p>
                  <div className="newsletter-input-tech">
                    <input
                        type="email"
                        placeholder="Votre email"
                        className="email-input-tech"
                        style={{color: '#ffffff'}}
                      />
                  </div>
                </div>
                <button className="subscribe-btn-tech" style={{color: '#000000'}}>
                  S'abonner
                </button>
              </div>
            </div>
          </div>
          {/* Copyright et mentions légales */}
          <div className="footer-bottom-tech">
            <div className="copyright-tech">
              &copy; {new Date().getFullYear()} Applicodetech. Tous droits réservés.
            </div>
            <div className="legal-links-tech">
              <a href="/mentions-legales" className="legal-link-tech">Mentions légales</a>
              <span className="separator-tech">•</span>
              <a href="/confidentialite" className="legal-link-tech">Politique de confidentialité</a>
              <span className="separator-tech">•</span>
              <a href="/cookies" className="legal-link-tech">Cookies</a>
            </div>

          </div>
        </div>
      </footer>

  );
};

export default Footer;